// Métricas reais das Automações visuais (GET talkvia_funnels/:id/metrics) e a
// preferência local "Mostrar contadores" por usuário e conta.

export const COUNTERS_PREFERENCE_PREFIX = 'talkvia.funnels.showCounters';

export const METRIC_PERIODS = [
  { value: 7, label: 'Últimos 7 dias' },
  { value: 30, label: 'Últimos 30 dias' },
  { value: 90, label: 'Últimos 90 dias' },
];

export const countersPreferenceKey = (userId, accountId) =>
  `${COUNTERS_PREFERENCE_PREFIX}.${userId || 'anon'}.${accountId || '0'}`;

const browserStorage = () => {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

export const readCountersPreference = (key, storage = browserStorage()) => {
  try {
    return storage?.getItem(key) === '1';
  } catch {
    return false;
  }
};

export const writeCountersPreference = (
  key,
  value,
  storage = browserStorage()
) => {
  try {
    storage?.setItem(key, value ? '1' : '0');
    return true;
  } catch {
    return false;
  }
};

export const nodeMetricsFor = (metrics, nodeId) =>
  metrics?.nodes?.[nodeId] || null;

const numberFormatter = new Intl.NumberFormat('pt-BR', {
  maximumFractionDigits: 0,
});

export const formatMetricCount = value =>
  value === null || value === undefined || Number.isNaN(Number(value))
    ? '—'
    : numberFormatter.format(Number(value));

export const formatMetricPercent = value =>
  value === null || value === undefined || Number.isNaN(Number(value))
    ? '—'
    : `${Number(value).toLocaleString('pt-BR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 1,
      })}%`;

// Ganho potencial só existe quando o nó tem um valor manual (estimativa).
export const hasPotentialEstimate = node => Number(node?.potential) > 0;

// Os modelos usam números apenas demonstrativos; funis reais começam zerados.
export const withoutDemoMetrics = node => ({
  ...node,
  leads: 0,
  conversion: 0,
  investment: 0,
  potential: 0,
});
